export const POSITIVEINT_MINIMUM = 1;
export const UNSIGNED_MINIMUM = 0;
export const SIGNED_MINIMUM = -2147483648;
export const INTEGER_MAXIMUM = 2147483647;
